import { Counter, MyleCounterStyle } from "./Counters";
import { ICounters } from "./ICounters";

/**
 * Represents a set of result's counters.
 * Implements the ICounters interface to track unread results.
 */
class ResultsCounters implements ICounters {
    /** The number of unread results. */
    private readonly unreadResults: number;

    /**
     * Creates an instance of ResultsCounters.
     * @param {number} unreadResults - The number of unread results.
    */
    constructor(unreadResults: number) {
        this.unreadResults = unreadResults;
    }

    /**
     * Retrieves an array of Counter objects representing each type of result's counter.
     * @returns {Counter[]} An array of counters with their respective value, label and style.
     */
    public getCounters(): Counter[] {
        return [
            new Counter(this.unreadResults, "Tooltip_UnreadResults", MyleCounterStyle.blueCircleWithBackground)
        ];
    }

    /**
     * Determines if the counter can be displayed.
     * @returns {boolean} True if the counter can be displayed, otherwise false.
     */
    public showCounters(): boolean {
        return this.unreadResults !== 0;
    }
}

export { ResultsCounters };
